import * as firebase from 'firebase';

const firebaseConfigDev = {
  apiKey: "AIzaSyBT_Iq4V7tIyvbvygxpT2MYUOq44-r_ggw",
  authDomain: "v-car-park-dev.firebaseapp.com",
  databaseURL: "https://v-car-park-dev.firebaseio.com",
  projectId: "v-car-park-dev",
  storageBucket: "v-car-park-dev.appspot.com",
  messagingSenderId: "208060898852",
  appId: "1:208060898852:web:8678f726f9f1ae2badc2b1",
  measurementId: "G-6QTX1VJPND"
};

const firebaseConfig = {
  apiKey: "AIzaSyCBtQn-mXXlTCM3dSp_SR_hNiqxb-ssw98",
  authDomain: "v-car-park.firebaseapp.com",
  databaseURL: "https://v-car-park.firebaseio.com",
  projectId: "v-car-park",
  storageBucket: "v-car-park.appspot.com",
  messagingSenderId: "1032097431504",
  appId: "1:1032097431504:web:1552c3fdf4f669ff6303d5",
  measurementId: "G-LYRHH0JWJ9"
};

export const firebaseApp = firebase.initializeApp(firebaseConfigDev);

export const db = firebaseApp.firestore();
